import React, { useEffect, useState } from "react";
import "./VolunteerCards.css";
import Navbar from "../Home/Navbar";
import Footer from "../Home/Footer";

const VolunteerCards = () => {
  const [volunteers, setVolunteers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchVolunteers = async () => {
      try {
        const response = await fetch("https://api.garudasena.org/api/volunteers");
        if (!response.ok) {
          throw new Error("Failed to fetch volunteers");
        }
        const data = await response.json();
        setVolunteers(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchVolunteers();
  }, []);

  if (loading) {
    return <div className="loading-text">Loading volunteers...</div>;
  }

  if (error) {
    return <div className="error-text">Error: {error}</div>;
  }

  return (
           <>
      <Navbar />
    <div className="volunteer-container">
          {volunteers
          .filter(v =>
            (v.type === "Volunteer" && v.isPaid === 1) ||
            v.type === "Divyangjan"
          ).map((volunteer) => (
        <div key={volunteer.id} className="volunteer-card">
          <div className="image-wrapper">
            <img
              src={volunteer.profile_image}
              alt={volunteer.name}
              className="volunteer-image"
            />
          </div>
          <h3 className="volunteer-name">{volunteer.name}</h3>
        </div>
      ))}
    </div>
      <Footer/>
        </>
  );
};

export default VolunteerCards;
